<div class="headerWithIcon">
  <h2 class="padding5">Our Heroes</h2>
  <ion-icon class="padding5" name="pencil" ></ion-icon>
</div>
<!-- <div class="heroesContainer">
  <ion-row>
    <ion-col size="6" *ngFor="let hero of heroes">
      <div class="heroCard">
        <img [src]="hero.image" alt="{{hero.name}}" class="heroImage" />
        <h3 class="heroName">{{hero.name}}</h3>
        <p class="heroDescription">{{hero.description}}</p>
      </div>
    </ion-col>
  </ion-row>
</div> -->